import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=cc4a037c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=cc4a037c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc4a037c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc4a037c')) {
      api.createRecord('cc4a037c', component.options)
    } else {
      api.reload('cc4a037c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=cc4a037c&scoped=true&", function () {
      api.rerender('cc4a037c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ws4F1kdKW5tW/JS/comp/PopupBox.vue"
export default component.exports